export enum Package {
    MIN_30 = 'MIN_30',
    MIN_60 = 'MIN_60',
    DAY = 'DAY',
    WEEK = 'WEEK',
    MONTH = 'MONTH'
}
